import { BrowserRouter } from 'react-router-dom';
import { StoreProvider } from '../app/providers/StoreProvider';
import { TelegramProvider } from './providers/TelegramProvider';
import { AuthProvider } from '../app/providers/AuthProvider';
import { AppRouter } from './router';
import { useEffect } from 'react';
import NavMenu from '../components/NavMenu/NavMenu';
import { TadsWidgetProvider } from 'react-tads-widget';
import NotificationWrapper from '../components/Notifications/NotificationWrapper';

const AppContent: React.FC = () => {
  useEffect(() => {
    if (location.pathname === '/') {
      document.body.classList.add('main-page');
      document.body.classList.remove('tasks-page');
    } else if (location.pathname === '/tasks') {
      document.body.classList.add('tasks-page');
      document.body.classList.remove('main-page');
    } else {
      document.body.classList.remove('main-page', 'tasks-page');
    }
  }, [location.pathname]);

  // if (showStartScreen) {
  //   return <StartScreen onOpen={handleOpen} />;
  // }

  return (
    <>
      <AppRouter />
      <NavMenu />
    </>
  );
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <TadsWidgetProvider>
        <TelegramProvider>
          <StoreProvider>
            <AuthProvider>
              <AppContent />
              <NotificationWrapper />
            </AuthProvider>
          </StoreProvider>
        </TelegramProvider>
      </TadsWidgetProvider>
    </BrowserRouter>
  );
};

export default App;
